// Cài đặt › Quyền của tôi (nhân viên — docs/KE_HOACH_THANH_VIEN_DON_VI.md): đơn vị đang làm, vai trò, những việc được
// làm. Muốn thêm quyền thì nhờ chủ đơn vị (Cài đặt › Nhân viên của chủ).
import { useEffect } from 'react'
import { useAuth, refreshUnitAccess } from '@/lib/auth'
import { UNIT_PERMISSION_GROUPS, UNIT_PERMISSION_META, grantableUnitPermissions } from '@shoptrack/common/unit-permissions'
import { Check, X } from 'lucide-react'
import { cn } from '@/lib/utils'

export function MyAccessTab() {
  const auth = useAuth()
  const shop = auth.shops.find((s) => s.shopId === auth.activeShopId)
  // Mở mục này → đọc lại quyền mới nhất (chủ có thể vừa đổi)
  useEffect(() => { void refreshUnitAccess() }, [])
  const perms = new Set(shop?.staff?.permissions ?? [])
  const grantable = new Set(grantableUnitPermissions(shop?.tenantType, shop?.workModes))
  return (
    <div className="space-y-6">
      <div className="rounded-xl bg-raise p-5 shadow-card">
        <p className="text-sm text-muted">Bạn là nhân viên của</p>
        <p className="mt-0.5 text-lg font-medium text-ink">{shop?.name ?? 'Đơn vị'}</p>
        <p className="mt-2 text-sm text-inkSoft">
          Vai trò: <span className="font-medium text-ink">{shop?.staff?.roleName ?? 'Chưa có vai trò'}</span>
        </p>
      </div>
      <div className="space-y-4">
        {UNIT_PERMISSION_GROUPS.map((g) => {
          const list = g.permissions.filter((p) => grantable.has(p))
          if (!list.length) return null
          return (
            <section key={g.key} className="rounded-xl bg-raise shadow-card">
              <h3 className="border-b border-rule px-4 py-3 text-base text-ink">{g.label}</h3>
              <ul className="divide-y divide-rule">
                {list.map((p) => {
                  const on = perms.has(p)
                  return (
                    <li key={p} className="flex items-start gap-3 px-4 py-2.5">
                      {on ? <Check className="mt-0.5 size-4 shrink-0 text-ok" aria-label="Được làm" /> : <X className="mt-0.5 size-4 shrink-0 text-muted" aria-label="Không được làm" />}
                      <span className="min-w-0">
                        <span className={cn('block text-sm', on ? 'text-ink' : 'text-muted')}>{UNIT_PERMISSION_META[p].label}</span>
                      </span>
                    </li>
                  )
                })}
              </ul>
            </section>
          )
        })}
      </div>
    </div>
  )
}
